import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { IMAGES } from "@/content";

export const Hero = ({ t }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "25%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);

  return (
    <section id="hero" ref={ref} data-testid="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <motion.div style={{ y }} className="absolute inset-0">
        <img src={IMAGES.hero} alt="Calanchi di Pisticci" className="w-full h-full object-cover scale-110" />
        <div className="absolute inset-0 bg-black/45" />
        <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-[#0D0B0A] to-transparent" />
      </motion.div>

      <motion.div style={{ opacity }} className="relative z-10 text-center px-6 pt-16">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="text-xs tracking-[0.4em] uppercase text-[#D4A373] mb-8"
        >
          {t.hero.kicker}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.4 }}
        >
          <img src="/brand/mark.png" alt="Legend emblem" data-testid="hero-mark" className="h-24 sm:h-32 w-auto mx-auto mb-8" />
          <h1 className="sr-only">{t.hero.title}</h1>
          <img src="/brand/wordmark.png" alt="Legend" data-testid="hero-wordmark" className="w-[62vw] max-w-[480px] mx-auto" />
        </motion.div>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2, delay: 0.8 }}
          className="font-heading italic text-2xl sm:text-3xl text-[#D4A373] mt-8"
        >
          {t.hero.sub}
        </motion.p>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2, delay: 1.1 }}
          className="max-w-xl mx-auto mt-8 text-sm sm:text-base text-[#F4F0E6]/80 leading-relaxed"
        >
          {t.hero.desc}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.4 }}
          className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-5"
        >
          <span data-testid="hero-date" className="text-sm tracking-[0.25em] uppercase text-[#F4F0E6] border border-[#F4F0E6]/25 rounded-full px-6 py-3">
            {t.hero.date}
          </span>
          <a
            href="#join"
            data-testid="hero-cta"
            className="bg-[#D4A373] text-[#0D0B0A] rounded-full px-8 py-3 text-sm font-medium hover:bg-[#B87B41] transition-colors"
          >
            {t.hero.cta}
          </a>
        </motion.div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-[#A8A294] text-xs tracking-[0.3em] uppercase animate-pulse"
      >
        {t.hero.scroll} ↓
      </motion.div>
    </section>
  );
};
